import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { authConfig } from '../authentication/auth-config';
import { msConfig } from './ms-config';


@Injectable({
  providedIn: 'root'
})
export class AppInitializerService {
  private static ME;

  constructor(private http: HttpClient) {
    AppInitializerService.ME = this;
  }

  load(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.loadKeycloack((err1: any) => {
        if (err1) {
          reject(err1);
          return;
        }
        this.setEdithConfig((err2: any) => {
          if (err2) {
            reject(err2);
          } else {
            resolve(true);
          }
        });
      });
    });
  }

  // caricamento file keycloak javascript adapter
  private loadKeycloack(callback) {
    
    let script = document.createElement('script');
    document.body.appendChild(script);

    // set script source: will trigger the download
    script.src = 'assets/keycloak.js';

    script.onload = () => {
      // the function is available
      //alert("keycloak.js download ok");
      callback(null);
    };
    script.onerror = () => {
      // the script has not loaded
      // alert("keycloak.js download ko");
      location.reload();
      callback();
    };
  }

  // recupero info di configurazione e costruzione oggetto
  private setEdithConfig(callback){
    AppInitializerService.ME.http
    .get("config/edith-config.json", { responseType: 'text' as 'json' })
    .subscribe(
      (res: any) =>{
        let edithConfig = JSON.parse(res);
        let env = edithConfig['env'];
        let ssoConfig = edithConfig['sso-config'];
        let microserviziConfig = edithConfig['ms-config'];

        // auth config
        authConfig['realm'] = ssoConfig['realm'];
        authConfig['url'] = ssoConfig['url'];
        authConfig['ssl-required'] = ssoConfig['ssl-required'];
        authConfig['clientId'] = ssoConfig['clientId'];
        authConfig['confidential-port'] = ssoConfig['confidential-port'];
        authConfig['redirectUri'] = ssoConfig['redirectUri'];
        authConfig['timeUpdateTokenBeforeExpires'] = ssoConfig['timeUpdateTokenBeforeExpires'];

        switch(env){
          case "dev":
            authConfig['credentials']['secret'] = "7eec2eb0c02b5582a6c09786ad8794fd";
            break;
          case "test":
            authConfig['credentials']['secret'] = "1416be752c0c93bfdcf36b4f6f10669c";
            break;
          case "pre-gdc":
            authConfig['credentials']['secret'] = "d4e517b2aa54c7fbea3826c0656f6bbe";
            break;
          case "pre-crema":
            authConfig['credentials']['secret'] = "d54320661fa65c61c57405fa3959da94";
            break;
          case "prod-gdc":
            authConfig['credentials']['secret'] = "7b83fd8fa328b3c39e5a5ae76b8413ff";
            break;
          case "prod-crema":
            authConfig['credentials']['secret'] = "18ba6dec215fe7c430932203832a708f";
            break;

        }

        // ms config
        msConfig['ms-utenti'] = microserviziConfig['ms-utenti'];
        msConfig['ms-ordini'] = microserviziConfig['ms-ordini'];
        msConfig['ms-notifiche'] = microserviziConfig['ms-notifiche'];
        msConfig['ms-svincoli'] = microserviziConfig['ms-svincoli'];
        msConfig['ms-documenti'] = microserviziConfig['ms-documenti'];
        msConfig['ms-fornitori'] = microserviziConfig['ms-fornitori'];
        msConfig['ms-non-conformita'] = microserviziConfig['ms-non-conformita'];
        msConfig['ms-collaudi'] = microserviziConfig['ms-collaudi'];

        callback(null);
      },
      (err) => callback(err)
    );
  }
  

}
